
import Link from "next/link";
import Image from "next/image";
import MoreBtn from "@/components/comman/MoreBtn";
import BrandSlider from "@/components/comman/BrandSlider";
import ScrollToElement from "@/components/comman/SectionScroll";
import StartaProject from "@/components/StartaProject";
import { GetStaticPaths, GetStaticProps } from 'next';
import { getSingleProjectData } from '@/lib/projects';
import {getSeoDataProjects} from '@/lib/seo';
import SEO from '@/components/SEO';

function Work({initialProject, initialSeo}:any) {

    const billboard = initialProject?.node?.projects?.billboard;
    const billboardBG = initialProject?.node?.projects?.projectsBackgroundImage;
    const enquirySection = initialProject?.node?.projects?.enquirySection;
    const featuresSection = initialProject?.node?.projects?.featuresSection;
    const testimonialsSection = initialProject?.node?.projects?.testimonialsSection;
    const projectOverview = initialProject?.node?.projects?.projectOverview;
    const ourWorkWithUs = initialProject?.node?.projects?.ourWorkWithUs;
    const workFullScreenshot = initialProject?.node?.projects?.workFullScreenshot;
    const featureProject = initialProject?.node?.projects?.featureProject;
    
  return (

    <div className='single_work_page'>   

        <SEO initialSeo={initialSeo}/>

        {/* billboard start */}
        <section className='full_banner'>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="left_banner">
                            <div className="caption">
                                {
                                    billboard?.subTitle && (
                                        <span className='sub_heading' data-aos="fade-right" data-aos-delay="100">{billboard?.subTitle}</span>
                                    )
                                }
                                <h2 data-aos="fade" data-aos-delay="100">{initialProject?.node?.title}</h2>
                                <div className="billboard_content"  dangerouslySetInnerHTML={{ __html: billboard?.description || '' }}></div>
                               {
                                billboard?.button?.url && (
                                    <Link href={`${billboard?.button?.url}`} className="cmn_btn" data-aos="fade-up" data-aos-delay="100">
                                        <span>{billboard?.button?.title}</span>
                                    </Link>
                                )
                               }
                                    
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="right_banner">
                            <div className="right_img" data-aos="fade-left" data-aos-delay="100">
                                {
                                    billboardBG && (
                                    <Image src={`${billboardBG?.sourceUrl  || '/'}`} alt={`${billboardBG?.altText  || 'billboard'}`} width={1105} height={944} loading="eager"/>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MoreBtn sectionId='bookacall'/>
        </section>
        {/* billboard end */}

        {/* Book A Call Section Start */}
        {
            enquirySection?.enquirySectionTitle && enquirySection?.enquirySectionDescription && (
            <section id='bookacall' className='section'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="section_title">
                                <h2 data-aos="fade" data-aos-delay="100">{enquirySection?.enquirySectionTitle}</h2>
                            </div>
                            <p data-aos="fade" data-aos-delay="200">
                                {enquirySection?.enquirySectionDescription}
                            </p>
                            {
                                enquirySection?.enquirySectionButton?.url && (
                                    <Link href={`${enquirySection?.enquirySectionButton?.url}`} className='cmn_btn_fill' data-aos="fade-down" data-aos-delay="100">
                                        <span>{enquirySection?.enquirySectionButton?.title}</span>
                                    </Link>
                                )
                            }
                        </div>
                        <div className="col-lg-7 col-lg-7 offset-lg-1 col-md-12">
                            <div className="row gx-5">
                                {
                                    enquirySection?.enquirySectionBoxes && (
                                        <>        
                                            {
                                                enquirySection?.enquirySectionBoxes.map((eb:any,index:any)=>{
                                                    return(
                                                    <div key={index} className="col-lg-4">
                                                        <div className="www_box" data-aos="fade" data-aos-delay="100">
                                                            <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                                {
                                                                    eb?.enquirySectionBoxIcon?.sourceUrl && (
                                                                        <Image src={`${eb?.enquirySectionBoxIcon?.sourceUrl}`} alt={eb?.enquirySectionBoxTitle} width={41} height={40} loading="lazy"/>
                                                                    )
                                                                }
                                                            </div>
                                                            <h3 className='f24 fw-800'>{eb?.enquirySectionBoxTitle}</h3>
                                                            <p>
                                                                {eb?.enquirySectionBoxDescription}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    )
                                                })
                                            }   
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            )
        }
        {/* Book A Call Section End */}

        {
            featuresSection?.featuresSectionTitle && featuresSection?.featuresSectionDescription && (
            <section className='section position-relative theme_black'>
                    <ScrollToElement targetId="testimonial" buttonClassName="section_scroll"/>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 white">
                                <h2 data-aos="fade" data-aos-delay="100">{featuresSection?.featuresSectionTitle}</h2>    
                            </div>
                            <div className="col-lg-7 col-lg-7 offset-lg-1 col-md-12">
                                <div className="sb_right white">
                                    <p data-aos="fade" data-aos-delay="200">
                                        {featuresSection?.featuresSectionDescription}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {
                            featuresSection?.featuresSectionBoxes && (
                                <div className="sb_list white">
                                    <div className="row gx-5">
                                        {
                                            featuresSection?.featuresSectionBoxes.map((fb:any,index:any)=>{
                                                return (
                                                    <div key={index} className="col-lg-4">
                                                        <div className="www_box" data-aos="fade" data-aos-delay="100">
                                                            <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                                <Image src={`${fb?.featuresSectionBoxIcon?.sourceUrl}`} alt={fb?.featuresSectionBoxTitle} width={41} height={33}  loading="lazy"/>
                                                            </div>
                                                            <h3 className='f24 fw-800'>{fb?.featuresSectionBoxTitle}</h3>
                                                            <p>
                                                                {fb?.featuresSectionBoxDescription}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        }
                        
                    </div>
            </section>
            )
        }


        {/* brand slider start */}
        <section id='testimonial' className='section  border_top testimonial theme_black'>
            <div className="container">
                <BrandSlider/>
            </div>
        </section>
        {/* brand slider end */}

        {/* testimonial start */}
       {
            testimonialsSection?.selectTestimonials?.content && testimonialsSection?.selectTestimonials?.title && (
                <section className='img_testimonial'>
                    <div className="container">
                        <div className="iTstimonial">
                            <div className="iTestiBox">
                                <div className="iTesti_img" >
                                    {
                                        testimonialsSection?.selectTestimonials?.featuredImage?.node?.sourceUrl && (
                                            <Image src={testimonialsSection?.selectTestimonials?.featuredImage?.node?.sourceUrl ||  '/images/placeholder.jpg'} alt={testimonialsSection?.selectTestimonials?.featuredImage?.node?.altText} width={458} height={439} data-aos="fade-right" data-aos-delay="100" loading="lazy"/>
                                        )
                                    }
                                </div>
                                <div className="iTestContent">
                                    <div className="it_description" dangerouslySetInnerHTML={{ __html: testimonialsSection?.selectTestimonials?.content || '' }}></div>
                                    <div className="iTestInfo">
                                        
                                        <div className="brand_logo" data-aos="fade-down" data-aos-delay="100">
                                        {
                                            testimonialsSection?.selectTestimonials?.testimonial?.companyLogo?.sourceUrl && (
                                                <Image src={testimonialsSection?.selectTestimonials?.testimonial?.companyLogo?.sourceUrl ||  '/images/placeholder.jpg'} alt={testimonialsSection?.selectTestimonials?.testimonial?.companyLogo.altText} width={228} height={50} loading="lazy"/>
                                            )
                                        }
                                        </div>
                                        <div className="client_details">
                                            <h3 data-aos="fade" data-aos-delay="100" >{testimonialsSection?.selectTestimonials?.title}</h3>
                                            {
                                                testimonialsSection?.selectTestimonials?.testimonial?.designation && (
                                                    <span data-aos="fade" data-aos-delay="200">{testimonialsSection?.selectTestimonials?.testimonial?.designation}</span>
                                                )
                                            }
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        {/* testimonial end */}

        {/* zig zag  with laptop screen design start --------- */}
        {/* {
            projectOverview?.title && projectOverview?.projectBackgroundImage?.sourceUrl && (
            <section className="section">
                <div className="zig50 reverse">
                    <div className="zig50_left" style={{backgroundImage: `url('${projectOverview?.projectBackgroundImage?.sourceUrl}')`}}>
                        <div className="zig50_center">
                            <div className="laptop" data-aos="fade-left" data-aos-delay="100">
                                <Image src="/images/macbookpro.png" alt="macbookpro  apple" width={1263} height={831}  loading="lazy"/>
                                <div id="macScreen" style={{backgroundImage: `url('${projectOverview?.projectScreenImage?.sourceUrl}')`}}></div>
                            </div>
                        </div>
                    </div>

                    <div className="zig50_right">
                        <div className="zig50_content">
                            <div className="zig50_wrap">
                                    <h2 data-aos="fade" data-aos-delay="100">{projectOverview?.title}</h2>
                                    <div className="work_content" dangerouslySetInnerHTML={{ __html: projectOverview?.description || '' }}>
                                    
                                    </div>
                                    <Link href={`#1`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                        <span>View Project</span>
                                    </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            )
        } */}
        {/* zig zag  with laptop screen design end ------------ */}

        {
            projectOverview?.title && projectOverview?.projectBackgroundImage?.sourceUrl && (
            <section className="section without_screen">
                <div className="zig50 reverse">
                    <div className="zig50_left" style={{backgroundImage: `url('${projectOverview?.projectBackgroundImage?.sourceUrl}')`}}>
                        <div className="without_screen_img">
                            <Image src={projectOverview?.projectScreenImage?.sourceUrl || '/images/placeholder.jpg'} alt={projectOverview?.title || 'placeholder'} width={1067} height={653}/>
                        </div>
                    </div>

                    <div className="zig50_right">
                        <div className="zig50_content">
                            <div className="zig50_wrap">
                                    <h2 data-aos="fade" data-aos-delay="100">{projectOverview?.title}</h2>
                                    <div className="work_content" dangerouslySetInnerHTML={{ __html: projectOverview?.description || '' }}>
                                    
                                    </div>
                                    {/* <Link href={`#1`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                        <span>View Project</span>
                                    </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            )
        }


        {/* our work with Us start */}
        {
            ourWorkWithUs?.title && (
                <section className=''>
                    <div className="container">
                        <div className="section_title bottom center">
                            <h2 data-aos="fade" data-aos-delay="100">{ourWorkWithUs?.title}</h2>
                        </div>
                        {
                            ourWorkWithUs?.ourWorksBox && (
                            <div className="sb_list">
                                <div className="row gx-5">
                                    {
                                        ourWorkWithUs?.ourWorksBox.map((owb:any,index:any)=>{
                                            return(
                                                <div key={index} className="col-lg-3">
                                                    <div className="www_box" data-aos="fade" data-aos-delay="100">
                                                        <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                            {
                                                                owb?.ourWorkIcon && (
                                                                    <Image src={`${owb?.ourWorkIcon?.sourceUrl}`} alt={owb?.ourWorkTitle} width={40} height={41} loading="lazy"/>
                                                                )
                                                            }
                                                        </div>
                                                        <h3 className='f24 fw-800'>{owb?.ourWorkTitle}</h3>
                                                        <div>
                                                            <p>
                                                                {owb?.ourWorkDescription}
                                                            </p>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            )
                        }
                    </div>
                </section>
            )
        }
        {/* our work with Us end */}

        {/* project screen start */}
        {
         workFullScreenshot?.hide && (
            <section className="section pb-0">
                <div className="container">
                    <div className="project_screen">
                        <img src={`${workFullScreenshot?.screenshot?.sourceUrl}`} alt={`${workFullScreenshot?.screenshot?.sourceUrl || 'screen'}`} />
                    </div>
                </div>
            </section>
         )
        }
        {/* project screen end */}
        {
            featureProject?.selectProject?.title && (
                <section className="section pb-0 feature_project">
                <div className="container-fluid">
                        <div className="row g-0">
                            <div className="col-lg-6">
                                <div className="feature_project_img">
                                    <Image src={featureProject?.selectProject?.projects?.projectsBackgroundImage?.sourceUrl} alt={featureProject?.selectProject?.title} width={1244} height={1185}/>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="new_feature_project_content">
                                    <span className="sub_heading" data-aos="fade-right" data-aos-delay="100">Design & Branding</span>
                                    <h2 data-aos="fade" data-aos-delay="100">{featureProject?.selectProject?.title}</h2>
                                    <div className="work_content" dangerouslySetInnerHTML={{ __html: featureProject?.selectProject?.content || '' }}>

                                    </div>
                                    {featureProject?.selectProject?.slug && (
                                    <Link href={`/our-works/${featureProject?.selectProject?.slug}`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                                        <span>View Project</span>
                                    </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                </div>
                </section>
            )
        }

        <StartaProject/>

    </div>
  )
}

export default Work;

export const getStaticPaths: GetStaticPaths = async () => {
    // Fetch all services and generate paths for each service's slug
    const projects = await getSingleProjectData();
    const paths = projects.map((industrie: any) => ({
      params: { slug: industrie.node.slug },
    }));
  
    return { paths, fallback: false }; // fallback: false means other routes should 404
  };
    
    // This function gets the data for each individual service page
export const getStaticProps: GetStaticProps = async ({ params }: any) => {
    const slug = params.slug;
    const initialProjects = await getSingleProjectData();
    const initialSeo = await getSeoDataProjects(slug)
    const initialProject = initialProjects.find((s: any) => s.node.slug === slug);
    return { props: { initialProject, initialSeo } };
    
};

